import React, { Component } from "react";
import ModalItem from "./ModalItem";
import EditarPolizaManual from "../Pages/Panel/Polizas/EditarPolizaManual/EditarPolizaManual";

/*
  Abre el formulario de Editar Poliza dentro de un modal, reutilizando la misma
  pagina que vive en /panel/editarPolizaManual (montada con embedded, sin PageHeader).

  Se monta solo cuando visible es true y con key={polizaId}, para que al abrirlo con
  otra poliza se remonte y vuelva a consultar (mismo efecto que el componentDidUpdate
  sobre visible que usan los demas modales del proyecto).

  empresaId es opcional y solo lo manda el PanelPrincipal (herramientas internas de Biwo,
  que operan sobre la empresa de un cliente). Sin el, EditarPolizaManual usa la empresa
  de la sesion como siempre.
*/
class ModalEditarPoliza extends Component {
  render() {
    const { visible, polizaId, empresaId, onCancel, onGuardado } = this.props;
    return (
      <ModalItem
        title="Editar Poliza"
        visible={visible}
        onCancel={onCancel}
        paddingTop
        width={1100}
        footer={null}
        spinning={false}
      >
        {visible && polizaId ? (
          <EditarPolizaManual
            key={polizaId}
            polizaId={polizaId}
            empresaId={empresaId}
            embedded
            onCerrar={onCancel}
            onGuardado={onGuardado}
          />
        ) : null}
      </ModalItem>
    );
  }
}

export default ModalEditarPoliza;
